import { render } from "./swipe.vue?vue&type=template&id=a11856f2&scoped=true"
import script from "./swipe.vue?vue&type=script&lang=js"
export * from "./swipe.vue?vue&type=script&lang=js"

import "./swipe.vue?vue&type=style&index=0&id=a11856f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11856f2"]])

export default __exports__